import Vue from 'vue'
import App from './App.vue'
import Modal from "@/components/Modal"
import Loading from "@/components/Loading"
import "./i18n"
import router from "@/router"
import VueCarousel from 'vue-carousel';
import VTooltip from 'v-tooltip'
import VueScrollReveal from 'vue-scroll-reveal';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faEyeSlash, faExclamationCircle, faCircleNotch, faSearchMinus, faSearchPlus, faPlay, faFileAlt, faCloudDownloadAlt, faArrowRight, faComments, faCircle, faWalking, faQuestionCircle, faSignal, faTimes, faSignInAlt, faLock, faEnvelope, faArrowLeft, faMinus, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faEyeSlash, faExclamationCircle, faCircleNotch, faSearchMinus, faSearchPlus, faPlay, faFileAlt, faArrowRight, faComments, faCircle, faWalking, faQuestionCircle, faSignal, faTimes, faSignInAlt, faLock, faEnvelope, faArrowLeft, faMinus, faPlus, faCloudDownloadAlt)

Vue.use(VueCarousel);
Vue.use(VTooltip, {
  defaultContainer: '#tracker',
});
Vue.use(VueScrollReveal);

Vue.component('modal', Modal)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('loading', Loading)


import "./assets/css/reset.scss"
import "./assets/css/tooltip.scss"
import "./assets/css/main.scss"
import store from './store'

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app');
